// extracted by mini-css-extract-plugin
export default {"image":"index-module__image--9h+y5"};